import { ReactNode } from "react";
import { PropertyContext } from "./property-context";
import { useNotificationTemplateData } from "../use-notification-template-data";

export function ProvidePropertyByTemplateId({
  templateId,
  children,
}: {
  templateId: string;
  children: ReactNode;
}) {
  const { data } = useNotificationTemplateData(templateId);

  return (
    <PropertyContext.Provider
      value={data?.getNotificationTemplateById.properties ?? []}
    >
      {children}
    </PropertyContext.Provider>
  );
}
